import { render } from "./UploadPanel.vue?vue&type=template&id=64f77696&scoped=true"
import script from "./UploadPanel.vue?vue&type=script&lang=js"
export * from "./UploadPanel.vue?vue&type=script&lang=js"

import "./UploadPanel.vue?vue&type=style&index=0&id=64f77696&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f77696"]])

export default __exports__